module.exports = __webpack_public_path__ + "static/whatsapp-1-8f7873a7ed82e6a7c15e3e19c1dc4ab1.png";